import {ReportData} from "../../report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {EmployeeReportSelectionData} from "../../../employee/employee/controls/employee-report-selection-control.component";
import {SupplierReportSelectionData} from "../../../stock/supplier/controls/supplier-report-selection-control.component";
import {AccessRoleReportSelectionData} from "../../../employee/access-role/controls/access-role-report-selection-control.component";
import {OutletReferenceData} from "../../../pos/outlet/outlet.data";
import {
    InventoryReportSelectionData
} from "../../../stock/inventory/controls/inventory-report-selection-control.component";

export class CustomReportData extends ReportData<CustomReportData> {
    @field reportId: string;

    @field outletGroupId: number;

    @field includeReceivedOrders: boolean = true;
    @field includeReceivableOrders: boolean = true;
    @field includePendingPurchaseOrders: boolean = false;
    @field includePendingReceiveOrders: boolean = false;
    @field includePendingStockTransfers: boolean = false;

    // employee status
    @field includeEmployeeStatusFullTime: boolean = true;
    @field includeEmployeeStatusPermanentPartTime: boolean = true;
    @field includeEmployeeStatusPartTime: boolean = true;
    @field includeEmployeeStatusCasual: boolean = true;
    @field includeEmployeeStatusUnemployed: boolean = false;

    // best/worst sellers
    @field best: boolean = true;
    @field orderBy: string = "Quantity";
    @field limit: number = 10;

    @collection() stockMovement: String[];
    @collection(EmployeeReportSelectionData) employees: EmployeeReportSelectionData[];
    @collection(SupplierReportSelectionData) suppliers: SupplierReportSelectionData[];
    @collection(InventoryReportSelectionData) inventories: InventoryReportSelectionData[];
    @collection(AccessRoleReportSelectionData) accessRoles: AccessRoleReportSelectionData[];
    @collection(OutletReferenceData) outlets: OutletReferenceData[];
}
